import { Button } from 'ui';
import styled from 'styled-components';

export default styled(Button)`
  text-transform: uppercase;
  border: 2px solid #6f7e95 !important;
  color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
  background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  &:hover {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
    opacity: 0.7 !important;
  }
  &:focus {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  }
  &:disabled {
    opacity: 0.7;
  }
  ${p => p.marginTop && `margin-top: ${p.marginTop}px`};
`;
